<template>
  <div>
    <span class="national-blue-bar"></span>
    <div class="national-title">법안 처리율</div>
    <MobileScroll />
    <div class="table-wrap">
      <table class="national-table">
        <tr>
          <th>발의주체</th>
          <th>의원</th>
          <th>위원장</th>
          <th>정부</th>
          <th>계</th>
        </tr>
        <!-- 발의건 -->
        <tr>
          <td>발의(건)</td>
          <td
            v-for="(item, index) in statisticsBiilCountData.proposalCountList"
            :key="`proposalCountList${index}`"
          >
            {{ item.toLocaleString() }}
          </td>
        </tr>
        <tr class="blue-row">
          <td>처리(건)</td>
          <td
            v-for="(item, index) in statisticsBiilCountData.processingCountList"
            :key="`processingCountList${index}`"
          >
            {{ item.toLocaleString() }}
          </td>
        </tr>
        <tr class="red-row">
          <td>미처리(건)</td>
          <td
            v-for="(
              item, index
            ) in statisticsBiilCountData.unprocessedCountList"
            :key="`unprocessedCountList${index}`"
          >
            {{ item.toLocaleString() }}
          </td>
        </tr>
        <tr>
          <td>처리율(%)</td>
          <td
            v-for="(
              item, index
            ) in statisticsBiilCountData.processingPercentList"
            :key="`processingPercentList${index}`"
          >
            {{ item.toLocaleString() }}%
          </td>
        </tr>
      </table>
    </div>

    <!--  -->

    <span class="national-blue-bar sky"></span>
    <span class="national-blue-bar"></span>
    <div class="national-title">법안처리 유형</div>

    <div class="table-wrap">
      <table class="national-table sub-auto">
        <tr>
          <th colspan="2">발의주체</th>
          <th colspan="2">의원</th>
          <th colspan="2">위원장</th>
          <th colspan="2">정부</th>
          <th colspan="2">계</th>
        </tr>
        <tr class="sky">
          <td colspan="2">처리(건)</td>
          <td
            colspan="2"
            v-for="(item, index) in statisticsBiilCountData.processingCountList"
            :key="`processingCountList_${index}`"
          >
            {{ item.toLocaleString() }}
          </td>
        </tr>
        <!--  -->
        <tr>
          <td rowspan="5">법률 반영</td>
          <td class="not">원안가결</td>
          <!-- 원안가결(건/비율) -->
          <td
            v-for="(
              item, index
            ) in statisticsBiilCountBottomData.OBIL_PSSG_CNT_LIST"
            :key="`OBIL_PSSG_CNT_LIST_${index}`"
          >
            {{ item.toLocaleString() }}{{ index % 2 === 0 ? "" : "%" }}
          </td>
        </tr>
        <tr>
          <td>수정가결</td>
          <!-- 수정가결(건/비율) -->
          <td
            v-for="(
              item, index
            ) in statisticsBiilCountBottomData.AMND_PSSG_CNT_LIST"
            :key="`AMND_PSSG_CNT_LIST_${index}`"
          >
            {{ item.toLocaleString() }}{{ index % 2 === 0 ? "" : "%" }}
          </td>
        </tr>
        <tr>
          <td>대안반영폐기</td>
          <!-- 대안반영폐기(건/비율) -->
          <td
            v-for="(
              item, index
            ) in statisticsBiilCountBottomData.ALTPL_REFT_CNT_LIST"
            :key="`ALTPL_REFT_CNT_LIST_${index}`"
          >
            {{ item.toLocaleString() }}{{ index % 2 === 0 ? "" : "%" }}
          </td>
        </tr>
        <tr>
          <td>수정안반영폐기</td>
          <!-- 수정안반영폐기(건/비율) -->
          <td
            v-for="(
              item, index
            ) in statisticsBiilCountBottomData.AMND_REFT_CNT_LIST"
            :key="`AMND_REFT_CNT_LIST_${index}`"
          >
            {{ item.toLocaleString() }}{{ index % 2 === 0 ? "" : "%" }}
          </td>
        </tr>
        <tr>
          <td>법률반영 소계</td>
          <!-- 법률반영 소계(건/비율) -->
          <td
            v-for="(
              item, index
            ) in statisticsBiilCountBottomData.REFT_SUBT_LIST"
            :key="`REFT_SUBT_LIST_${index}`"
          >
            {{ item.toLocaleString() }}{{ index % 2 === 0 ? "" : "%" }}
          </td>
        </tr>
        <tr>
          <td rowspan="5">법률 미반영</td>
          <td class="not">부결</td>
          <!-- 부결(건/비율) -->
          <td
            v-for="(
              item, index
            ) in statisticsBiilCountBottomData.RJCTN_CNT_LIST"
            :key="`RJCTN_CNT_LIST_${index}`"
          >
            {{ item.toLocaleString() }}{{ index % 2 === 0 ? "" : "%" }}
          </td>
        </tr>
        <tr>
          <td>폐기</td>
          <!-- 폐기 건수(건/비율) -->
          <td
            v-for="(item, index) in statisticsBiilCountBottomData.DSU_CNT_LIST"
            :key="`DSU_CNT_LIST_${index}`"
          >
            {{ item.toLocaleString() }}{{ index % 2 === 0 ? "" : "%" }}
          </td>
        </tr>
        <tr>
          <td>철회</td>
          <!-- 철회 건수(건/비율) -->
          <td
            v-for="(item, index) in statisticsBiilCountBottomData.WTHD_CNT_LIST"
            :key="`WTHD_CNT_LIST_${index}`"
          >
            {{ item.toLocaleString() }}{{ index % 2 === 0 ? "" : "%" }}
          </td>
        </tr>
        <tr>
          <td>기타</td>
          <!-- 기타 건수(건/비율) -->
          <td
            v-for="(item, index) in statisticsBiilCountBottomData.ETC_CNT_LIST"
            :key="`ETC_CNT_LIST_${index}`"
          >
            {{ item.toLocaleString() }}{{ index % 2 === 0 ? "" : "%" }}
          </td>
        </tr>
        <tr>
          <td>법률미반영 소계</td>
          <!-- 법률미반영 소계 (건/비율) -->
          <td
            v-for="(
              item, index
            ) in statisticsBiilCountBottomData.UN_REFT_SUBT_LIST"
            :key="`UN_REFT_SUBT_LIST_${index}`"
          >
            {{ item.toLocaleString() }}{{ index % 2 === 0 ? "" : "%" }}
          </td>
        </tr>
      </table>
    </div>
    <!--  -->
  </div>
</template>

<script>
import MobileScroll from "../common/MobileScroll.vue";

export default {
  name: "NThNationalAssemblyTable",

  components: { MobileScroll },

  props: {
    statisticsBiilCountData: Object,
    statisticsBiilCountBottomData: Object,
  },
};
</script>

<style scoped>
.national-blue-bar {
  width: 70px;
  height: 5px;
  display: inline-block;
  background-color: #005aab;
  margin-bottom: 19px;
  border-radius: 0 5px 5px 0;
}

.national-blue-bar.sky {
  background-color: #b0d6f8;
  margin-right: 5px;
}

.national-title {
  font-family: GmarketSansMedium;
  font-size: 40px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1px;
  text-align: left;
  color: #005aab;
  margin-bottom: 49px;

  @media only screen and (max-width: 1040px) {
    text-align: center;
  }
}

.national-table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
  border-collapse: collapse;
  overflow: hidden;
  border-radius: 10px;
  border-style: hidden;
  box-shadow: 0 0 0 1px #cacaca;
  min-width: 700px;

  & th {
    padding: 21px 0;
    border: 1px solid #cacaca;
    background-color: #005aab;
    font-family: GmarketSansMedium;
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
  }
  & td {
    width: 20%;
    padding: 21px 0;
    border: 1px solid #cacaca;
    font-family: GmarketSansMedium;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #000;
    vertical-align: middle;
  }

  & tr.red-row td {
    color: #de0000;
  }

  & tr.blue-row td {
    color: #005aab;
  }
}

.national-table.sub-auto {
  table-layout: fixed;

  & .sky {
    background-color: #e7f4ff;

    & td {
      color: #005aab;
      width: auto !important;
      vertical-align: middle;
    }
  }

  & td {
    width: auto;
    max-width: 10px !important;
    vertical-align: middle;
  }

  & tr td:nth-child(n + 2) {
    width: 100px;
    vertical-align: middle;
  }

  .not {
    width: auto !important;
  }
}

.table-wrap {
  width: 100%;
  margin-bottom: 100px;
  overflow-x: scroll;
  padding: 1px;
}
</style>
